import React, { Component } from "react";
import PropTypes from 'prop-types';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';

import { connect } from "react-redux";

import { Link } from "react-router-dom";

// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import RightSidebar from '../CommonForBoth/RightSidebar';

import megamenuImg from "../../assets/images/megamenu-img.png";
import logo from "../../assets/images/broker-name.png";
import logoLight from "../../assets/images/broker-name.png";
import logoLightSvg from "../../assets/images/broker-name.png";
import logoDark from "../../assets/images/broker-name.png";

import noLogo from "../../assets/images/no-logo.png"
import { getUserDetail, getClientDetail, getClientDetails  } from "../../store/actions";


//i18n
import { withTranslation } from "react-i18next";

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSearch: false,
      open: false,
      position: 'right',
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
    this.toggleSearch = this.toggleSearch.bind(this)
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
  }

  toggleSearch = () => {
    this.setState({ isSearch: !this.state.isSearch })
  }
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.openLeftMenuCallBack()
  }

  /**
   * Toggles the sidebar
   */
  toggleRightDrawer() {
    this.setState({ position: 'right' });
    this.setState({ open: !this.state.open });
  }
  closeDrawer() {
    this.setState({ open: false });
  }
  onDrawerClose() {
    this.setState({ open: false });
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }
  componentDidMount() {
      const { onGetUserDetail, onGetClientDetails } = this.props;
      if (onGetUserDetail) {
        onGetUserDetail(localStorage.getItem("agentId"), localStorage.getItem("userId"));
      
      }
        onGetClientDetails(localStorage.getItem("userId"));
  }
  render() {
    const {userdetail, clientDetails } = this.props;
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                   <Link to="/">
              {userdetail?.logoFilePath ? 
              <img className="site-logo" style={{height:60, paddingTop:10}} src={userdetail?.logoFilePath}/>
              : <img className="site-logo" style={{height:60}} src={noLogo} /> }
              </Link>
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoLightSvg} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <Link to="/">
              {userdetail?.logoFilePath ? 
              <img className="site-logo" style={{height:60, paddingTop:10}} src={userdetail?.logoFilePath}/>
              : <img className="site-logo" style={{height:60}} src={noLogo} /> }
              </Link>
                  </span>
                </Link>
              </div>

              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
                data-toggle="collapse"
                onClick={this.toggleMenu}
                data-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars" />
              </button>

             
              
            </div>

            <div className="d-flex">
              

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
                <Link to="/project-compare"><button
                  type="button"
                  className="btn header-item noti-icon"
                  
                >
                  <i className="bx bx-git-compare" />
                  <span className="badge bg-danger rounded-pill">0</span>
                </button></Link>
              </div> */}

             
            


              <NotificationDropdown />

              <ProfileMenu userdetail={userdetail} clientDetail={clientDetails} />

             
            </div>
          </div>
        </header>
       
      </React.Fragment>
    )
  }
}

Header.propTypes = {
  openLeftMenuCallBack: PropTypes.func,
  t: PropTypes.any,
  toggleRightSidebar: PropTypes.func,
  userdetail: PropTypes.object,
  onGetUserDetail: PropTypes.func,
  clientDetails:PropTypes.object,
  onGetClientDetails:PropTypes.func
}
const mapStateToProps = ({ Login }) => (
  {
   
    userdetail:Login.userdetail,
    clientDetails:Login.clientDetails
 
})
const mapDispatchToProps = (dispatch) => {
  return {
    onGetUserDetail: (agentId, clientId) => dispatch(getUserDetail(agentId, clientId)),
    onGetClientDetails: (userId) => dispatch(getClientDetails(userId)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation()(Header)
)
